import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { Element } from 'react-scroll';
import { useTranslation } from 'react-i18next';

const PHONE_DISPLAY = '+39 342 911 8790';
const PHONE_LINK = '+393429118790';
const EMAIL = 'info@taximoroder.it';

const Contact = ({ id }) => {
  const { t } = useTranslation();

  return (
    <Element name={id}>
      <section className="contactSection" aria-labelledby="contact-title">
        <div className="contactCard">
          <header className="contactHeader">
            <p className="contactEyebrow">{t('contact_header')}</p>
            <span>{t('contact_location')}</span>
          </header>

          <div className="contactMain">
            <div className="contactIntroduction">
              <h2 id="contact-title">{t('contact_title')}</h2>
              <p>{t('contact_intro')}</p>
            </div>

            <div className="contactDetails">
              <p className="contactBusiness">Taxi Moroder</p>
              <a className="contactDetail" href={`tel:${PHONE_LINK}`}>
                <i><LocalPhoneOutlinedIcon aria-hidden="true" /></i>
                <span><small>{t('contact_phone')}</small>{PHONE_DISPLAY}</span>
              </a>
              <a className="contactDetail" href={`mailto:${EMAIL}`}>
                <i><EmailOutlinedIcon aria-hidden="true" /></i>
                <span><small>{t('contact_email')}</small>{EMAIL}</span>
              </a>
              <a className="contactDetail" href="https://maps.google.com/?q=Via+Val+1,+39047+Santa+Cristina+Valgardena+BZ" target="_blank" rel="noopener noreferrer">
                <i><LocationOnOutlinedIcon aria-hidden="true" /></i>
                <span><small>{t('contact_address')}</small>Via Val 1, 39047 S. Cristina – BZ</span>
              </a>
            </div>
          </div>

          <div className="contactActions">
            <div className="contactActionCopy">
              <p>{t('contact_ready')}</p>
              <span>{t('contact_readyText')}</span>
            </div>
            <div className="contactButtons">
              <a className="contactButton contactButtonPrimary" href={`tel:${PHONE_LINK}`}><LocalPhoneOutlinedIcon />{t('contact_call')}</a>
              <a className="contactButton contactButtonWhatsApp" href={`https://wa.me/${PHONE_LINK.replace('+', '')}`} target="_blank" rel="noopener noreferrer"><WhatsAppIcon />WhatsApp</a>
              <a className="contactButton contactButtonEmail" href={`mailto:${EMAIL}`}><EmailOutlinedIcon />{t('contact_write')}</a>
            </div>
          </div>
        </div>
      </section>
    </Element>
  );
};

export default Contact;
